if (!customElements.get('wls-video')) {
  class WLSVideo extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        playButton: 'js-wls-video-play-button',
        playing: 'playing',
      };

      this.selectors = this.getSelectors();
      this._onVideoPlaying = () => {
        this.classList.add(this.classes.playing);
        this.updateButtonState(true);
      };
      this._boundVideoPlayingHandler = this.videoPlayingHandler.bind(this);

      this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
        threshold: 0.5,
      });
    }

    getSelectors() {
      return {
        playButton: this.querySelector(`.${this.classes.playButton}`),
        video: this.querySelector('video'),
      };
    }

    connectedCallback() {
      this.selectors = this.getSelectors();

      if (!this.selectors.video) return;

      this.observer.observe(this);

      const forcePauseControl = this.hasAttribute('data-force-pause-control');

      if (this.selectors.video.hasAttribute('autoplay')) {
        this.handleAutoplayVideo(forcePauseControl);
      }
      if ((!this.selectors.video.hasAttribute('autoplay') || forcePauseControl) && this.selectors.playButton) {
        this.selectors.playButton.addEventListener('click', this._boundVideoPlayingHandler);
      }
    }

    handleAutoplayVideo(forcePauseControl) {
      if (this.selectors.playButton && !forcePauseControl) {
        this.selectors.playButton.style.pointerEvents = 'none';
      }
      this.selectors.video.addEventListener('playing', this._onVideoPlaying);
    }

    disconnectedCallback() {
      const forcePauseControl = this.hasAttribute('data-force-pause-control');
      if (this.selectors.playButton && (!this.selectors.video?.hasAttribute('autoplay') || forcePauseControl)) {
        this.selectors.playButton.removeEventListener('click', this._boundVideoPlayingHandler);
      }
      this.selectors.video?.removeEventListener('playing', this._onVideoPlaying);
      this.observer.disconnect();
    }

    handleIntersection(entries) {
      entries.forEach((entry) => {
        if (!entry.isIntersecting && !this.selectors.video.paused) {
          this.videoPause();
        }
      });
    }

    pauseSyncedVideos() {
      if (this.hasAttribute('data-sync-pause')) {
        const allSyncedVideos = document.querySelectorAll('wls-video[data-sync-pause]');
        allSyncedVideos.forEach((videoElement) => {
          if (videoElement !== this && !videoElement.querySelector('video')?.paused) {
            videoElement.classList.remove(this.classes.playing);
            videoElement.querySelector('video')?.pause();
          }
        });
      }
    }

    videoPlayingHandler() {
      if (this.selectors.video.paused) {
        this.pauseSyncedVideos();
        this.videoPlay();
      } else {
        this.videoPause();
      }
    }

    videoPlay() {
      this.selectors.video.play();
      this.classList.add(this.classes.playing);
      this.updateButtonState(true);
    }

    videoPause() {
      const forcePauseControl = this.hasAttribute('data-force-pause-control');
      if (!this.selectors.video.hasAttribute('autoplay') || forcePauseControl) {
        this.selectors.video.pause();
        this.classList.remove(this.classes.playing);
        this.updateButtonState(false);
      }
    }

    updateButtonState(isPlaying) {
      const button = this.selectors.playButton;
      if (!button) return;
      button.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
      const label = isPlaying ? button.getAttribute('data-pause-label') : button.getAttribute('data-play-label');
      if (label) button.setAttribute('aria-label', label);
    }
  }

  customElements.define('wls-video', WLSVideo);
}

(function initWlsVimeoPosters() {
  document.querySelectorAll('img.wls-video-unified__vimeo-poster[data-vimeo-id]').forEach((img) => {
    const id = img.getAttribute('data-vimeo-id');
    if (!id) return;
    const url = `https://vimeo.com/api/oembed.json?url=${encodeURIComponent(`https://vimeo.com/${id}`)}`;
    fetch(url)
      .then((r) => r.json())
      .then((data) => {
        if (data.thumbnail_url) img.src = data.thumbnail_url;
      })
      .catch(() => {});
  });
})();